var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol-tooltip',{attrs:{"indicator":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"text-no-wrap text-truncate job-id"},on),[_vm._v("\n      "+_vm._s(_vm.jobId)+"\n    ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.jobId)+": "+_vm._s(_vm.jobName))])])}
var staticRenderFns = []

export { render, staticRenderFns }